import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      background: 'transparent',
      height: '833px',
      minWidth: '100%',
      padding: '0px 24px 24px 24px',
      [theme.breakpoints.down('lg')]: {
        height: '1660px'
      }
    },
    innerContainer: {
      background: 'white',
      borderRadius: '8px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      height: '809px',
      justifyContent: 'center',
      minWidth: '100%',
      // padding: '21px 3px',
      // padding: '16px',
      // display: 'grid',
      // gridTemplateRows: 'min-content min-content auto',
      [theme.breakpoints.down('lg')]: {
        height: '1640px'
      }
    },
    infoContainer: {
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      height: '100%',
      padding: '40px 48px 40px 48px',
      width: '590px'
    },
    syosContainer: {
      flex: '1 1 0%',
      justifyContent: 'center'
    },
    iframeContainer: {
      aspectRatio: '3/2',
      border: 'none',
      // border: '1px solid gray',
      height: '711px', // 767px, 700px, 711px
      // width: '1700px', // 1200px, 1700px, 1050px
      [theme.breakpoints.down('lg')]: {
        height: '580px'
      }
    },
    innerButtonsStack: {
      justifyContent: 'center',
      padding: '16px 0 0'
    },
    innerButton: {
      height: '50px',
      width: '220px'
    },
    /**
     * Copied from TicketSelectionView
     */
    ticketImageCard: {
      height: '370px',
      padding: 0,
      alignSelf: 'center',
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'center',
        maxHeight: '636px',
        width: '784px',
        padding: '48px 0 0',
        borderBottom: `1px solid ${color.LIGHT_GRAY}`
      },
      [theme.breakpoints.only('lg')]: {
        height: '421px',
        padding: '16px'
      }
    },
    ticketImage: {
      maxWidth: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    ticketDefaultImage: {
      height: '100%',
      objectFit: 'cover',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        objectFit: 'scale-down'
      }
    },
    eventDetailsBlock: {
      flexOverride: 'none',
      borderTop: `1px solid ${color.LIGHT_GRAY}`,
      padding: '48px 0 0 0',
      overflow: 'hidden',
      maxHeight: '350px',
      [theme.breakpoints.down('lg')]: {
        borderTop: 'none'
      }
    },
    ticketName: {
      fontWeight: 600,
      fontSize: '32px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.down('lg')]: {
        paddingLeft: '48px'
      }
    },
    ticketDateTime: {
      fontSize: '24px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.down('lg')]: {
        paddingLeft: '48px'
      }
    },
    eventDescription: {
      fontSize: '24px',
      fontWeight: 600,
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.down('lg')]: {
        padding: '0 48px'
      }
    },
    /**
     * SeatDetailsOverlay
     */
    seatDetailsTableContainer: {
      paddingTop: '20px'
    },
    seatDetailsTable: {
      width: 'calc(100% - 10px)',
      margin: '0 5px 40px'
    },
    seatDetailsTableRow: {
      alignItems: 'center',
      borderRadius: '8px',
      boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
      display: 'flex',
      margin: '12px 36px 24px',
      padding: '4px 8px'
    },
    seatDetailsTableCell: {
      border: 0,
      flex: '1'
    },
    seatDetailsCheckboxTableCell: {
      flex: '0 0 65px'
    }
  })
);
